export default __webpack_public_path__ + "static/media/640_dummy2016-irishpub01-de.aa3219c9.png";